
export enum EntityContextEnum {
  L = 0,			// Local Union
  U = 1,			// BargainingUnit
  O = 2,			// Generic Organizaton
  E = 3,			// CUPEStaff
  C = 4,			// Member
  S = 5,			// Service Contract Group
}

export enum AttendeeTypeEnum {
  S = 1,			// Staff
  O = 2,			// Observers
  OT = 3,			// Others
  M = 4,			// Media
  SP = 5,			// Special Guest
  G = 6,			// Guest Staff
  R = 7,			// Retired Staff
  N = 8,			// NEB
  C = 9,			// Committee
  NO = 10,		// No badge - Sectoral Meeting
  OB = 11,		// Observers Under 30
}

export enum ConventionGenderEnum {
  M = 1,			// Male
  F = 2,			// Female
  U = 3,			// Unspecified
  G = 4,			// Transgender
  S = 5,			// Transsexual
  I = 6,			// Intersex,
  N = 7,      // Gender non-conforming,
  T = 8,      // Two Spirit,
  H = 9,      // Heterosexual,
  MA = 10,    // Man,
  W = 11,     // Woman,
  Q = 12,     // Genderqueer,
  NB = 13,    // Non-binary,
}

export enum ConferenceGenderEnum {
  M = 1,			// Male
  F = 2,			// Female
  O = 3,      // Other
  U = 4,			// Unspecified
}

export enum ConventionLanguageEnum {
  EN = 1,			// English
  FR = 2,			// French
  BE = 3,			// Bilingual English
  BF = 4,			// Bilingual French
}

export enum ConventionOfficerTypeEnum {
  A = 1,			// Administrator
  EA = 2,			// Executive Assistant
  PS = 3,			// PerCapita Supervisor
  P = 4,			// President
  ST = 5,			// Secretary Treasurer
}

export enum ConventionRegistrationTypeEnum {
  D = 1,			// Delegate
  A = 2,			// Alternate
  O = 3,			// Other Attendee
  E = 4,			// Ex-Delegate
  EA = 5,			// Ex-Alternate
}

export enum ConventionTypeEnum {
  R = 1,			// Regular
  S = 2,			// Special
}

export enum EventStatusEnum {
  N = 1,			// Not active
  A = 2,			// Active
  C = 3,			// Cancelled
}

export enum EventTypeEnum {
  W = 1,			// Workshop
  WN = 2,			// Workshop(Non-CUPE)
  P = 3,			// Pilot
  F = 4,			// National Training
  S = 5,			// Special Event
  MS = 6,			// Multi-session
  C = 9,			// Conference
  CV = 10,		// Convention
}

export enum ExceptionListStatusEnum {
}

export enum HeuEnum {
}

export enum LanguageEnum {
  E = 1,			// English
  F = 2,			// French
  EF = 3,			// English and French
  B = 4,			// Bilingual
}

export enum MinorityGroupEnum {
  V = 1,			// Visible Minority
  A = 2,			// Aboriginal Peoples
  P = 3,			// Persons With Disabilities
  F = 4,			// Female
  L = 5,			// Lesbian
  G = 6,			// Gay
  T = 7,			// Transgender
  B = 8,			// Bisexual
  Y = 9,			// Young Worker
  TR = 10,		// Transsexual
  M = 11,			// Male
  H = 12,			// Heterosexual
  I = 13,			// Intersex,
  Q = 14,     // Queer
}

export enum NotQualifyReasonEnum {
  N = 1,			// No Per Capita Tax Paid
  OC = 2,			// Owing with cred letter
  A = 3,			// Affiliation fees
  C = 4,			// Conv Year Charted
  ON = 5,			// Owing no Cred Letter
}

export enum PaymentMethodEnum {
  C = 1,			// Cheque
  CS = 2,			// Cash
  A = 3,			// Asst.Fund
  F = 4,			// Free
  P = 5       // Paypal
}

export enum ProcessedEntityMailingTypeEnum {
  CL = 1,			// Credential Letters
  RL = 2,			// Reason Letters
  UN = 3,			// Unit Notification
}

export enum ProcessedEntityTypeEnum {
  /**
   * District Council
   */
  DistrictCouncil = 1,
  /**
  * Local
  */
  Local = 2,
  /**
  * SubLocal
  */
  SubLocal = 3,
  /**
  * Service Division
  */
  ServiceDivision = 4,
  /**
  * Provincial Council Of Union
  */
  ProvincialCouncilOfUnion = 5,
  /**
  * Provincial Division
  */
  ProvincialDivision = 6,
  /**
  * Service Contract Group
  */
  ServiceContractGroup = 7,
  /**
  * Provincial Occupation Group
  */
  ProvincialOccupationGroup = 8,
  /**
  * Other
  */
  Other = 9,
  /**
  * Officers
  */
  Officers = 10,
  /**
  * HEU
  */
  HEU = 11
}

export enum ProcessedStatusEnum {
  P = 1,			// Printed
  NP = 2,			// Not Processed
  E = 3,			// Emailed
}

export enum RegistrationApprovalStatusEnum {
  P = 1,			// Pending
  V = 2,			// Validated
  R = 3,			// Registered
}

export enum SectoralMeetingStatusEnum {
  A = 1,			// Active
  I = 2,			// Inactive
}

export enum RegistrationTypeEnum {
  Delegate = 0,
  Alternate = 1,
  Other = 2
}

export enum AlertTypeEnum {
  Success = 0,
  Warning = 1,
  Info = 2,
  Danger = 3
}


